var _path, _ellipse, _path2, _ellipse2, _path3, _ellipse3, _path4, _ellipse4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRectangle42E = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 60 60",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M12.003 22.5a2.5 2.5 0 0 1 2.5-2.5h31a2.5 2.5 0 0 1 2.5 2.5v15a2.5 2.5 0 0 1-2.5 2.5h-31a2.5 2.5 0 0 1-2.5-2.5v-15Z"
})), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
  cx: 40,
  cy: 48,
  fill: "#464D57",
  rx: 5,
  ry: 6,
  transform: "rotate(-90 40 48)"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#BABCC0",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M46 47v1c0 2.761-2.686 5-6 5s-6-2.239-6-5v-1"
})), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 20,
  cy: 12,
  fill: "#464D57",
  rx: 5,
  ry: 6,
  transform: "rotate(90 20 12)"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  stroke: "#BABCC0",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M14 13v-1c0-2.761 2.686-5 6-5s6 2.239 6 5v1"
})), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 20,
  cy: 48,
  fill: "#464D57",
  rx: 5,
  ry: 6,
  transform: "rotate(-90 20 48)"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  stroke: "#BABCC0",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M26 47v1c0 2.761-2.686 5-6 5s-6-2.239-6-5v-1"
})), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 40,
  cy: 12,
  fill: "#464D57",
  rx: 5,
  ry: 6,
  transform: "rotate(90 40 12)"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  stroke: "#BABCC0",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M34 13v-1c0-2.761 2.686-5 6-5s6 2.239 6 5v1"
})));
SvgRectangle42E.viewBox = '0 0 60 60';
const ForwardRef = /*#__PURE__*/forwardRef(SvgRectangle42E);
export default ForwardRef;